import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/pages/App';
import registerServiceWorker from './js/others/registerServiceWorker';
import './css/index.css';

const root = document.getElementById('root');

ReactDOM.render(<App />,root);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js